import { createApp } from 'vue';
import Search from './search/Search';
import store from './store';

if (document.querySelector('#search-page')) {
    createApp(Search).use(store).mount('#search-page');
} else if (document.querySelector('#search')) {
    createApp(Search).use(store).mount('#search');
}
